import React from 'react'
import { Stack,Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react'
function ChatLoading() {
  return (
    <>
    <Stack>
<Skeleton height='25px' />
<Skeleton height='25px' />
<Skeleton height='25px' />

<Skeleton height='25px' />
<Skeleton height='25px' />
<Skeleton height='25px' />

<Skeleton height='25px' />
<Skeleton height='25px' />
<Skeleton height='25px' />

<Skeleton height='25px' />
<Skeleton height='25px' />
<Skeleton height='25px' />
<Skeleton height='25px' />



</Stack>
  </>
  )
}

export default ChatLoading